import React, { Component } from 'react'

import CallBox from '../CallBox'
import SocialLinks from '../SocialLinks'

class SimpleHeader extends Component {
    render() {
        const { info } = this.props
        return (
            <div className="simple-header py-2" style={{ fontSize: '1.4em' }}>
                <div className="container d-flex flex-column flex-md-row justify-content-between sm-center">
                    <div>
                        {info.logo && (<span><img src={info.logo} style={{ maxHeight: 60 }} alt="" /><br /><br /></span>)}
                    </div>
                    <div>
                        <CallBox info={info} />
                    </div>
                    <div>
                        <SocialLinks />
                    </div>
                </div>
            </div>
        )
    }
}

export { SimpleHeader }


// WEBPACK FOOTER //
// ./src/components/sections/SimpleHeader.js